
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4AltF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d28e4ceb9a34789e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $d28e4ceb9a34789e$export$2e2bcd8739ae039 = {
    'fabric.atlassianSwitcher.administration': "Administraci\xf3n",
    'fabric.atlassianSwitcher.analytics': "An\xe1lisis",
    'fabric.atlassianSwitcher.assets': 'Activos',
    'fabric.atlassianSwitcher.atlassianHome': 'Inicio',
    'fabric.atlassianSwitcher.atlassianWebsiteTryProducts': 'Probar productos de Atlassian',
    'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription': "Colaboraci\xf3n en documentos",
    'fabric.atlassianSwitcher.chat': 'Chat',
    'fabric.atlassianSwitcher.companyHub': 'Centro empresarial',
    'fabric.atlassianSwitcher.confluenceDescriptionText': "Documentaci\xf3n y colaboraci\xf3n",
    'fabric.atlassianSwitcher.confluenceSpace': 'Espacio de Confluence',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.body': 'Prueba un producto para empezar a colaborar con tu equipo.',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.link': 'Explorar productos',
    'fabric.atlassianSwitcher.emptyState.exploreProducts.title': 'Empezar a usar Cloud',
    'fabric.atlassianSwitcher.errorEmptyPartialResults': 'No se pueden mostrar tus aplicaciones en este momento.',
    'fabric.atlassianSwitcher.errorFlag.description': 'Vuelve a intentarlo dentro de unos minutos. Si sigues sin poder unirte, <a>ponte en contacto con el servicio de soporte</a>.',
    'fabric.atlassianSwitcher.errorFlag.title': "No hemos podido a\xf1adirte a {product}",
    'fabric.atlassianSwitcher.errorHeading': 'Algo ha ido mal',
    'fabric.atlassianSwitcher.errorHeadingLoggedOut': "Tu cuenta de Atlassian est\xe1 desconectada",
    'fabric.atlassianSwitcher.errorHeadingUnverified': "La cuenta no est\xe1 verificada",
    'fabric.atlassianSwitcher.errorImageAltText': "Un robot estropeado y varias personas arregl\xe1ndolo.",
    'fabric.atlassianSwitcher.errorPartialResults': 'No se pueden mostrar algunas de tus aplicaciones en este momento.',
    'fabric.atlassianSwitcher.errorPartialResultsRefresh': "Actualiza la p\xe1gina o vuelve a intentarlo m\xe1s tarde.",
    'fabric.atlassianSwitcher.errorText': "Aunque nos encargamos de supervisar estos errores, no dudes en contactar con nosotros si se repiten despu\xe9s de actualizar la p\xe1gina.",
    'fabric.atlassianSwitcher.errorTextLoggedOut': "Vuelve a iniciar sesi\xf3n para utilizar el alternador de Atlassian.",
    'fabric.atlassianSwitcher.errorTextNetwork': "No hemos podido cargar esta lista. Vuelve a cargar la p\xe1gina e int\xe9ntalo de nuevo.",
    'fabric.atlassianSwitcher.errorTextUnverified': "Confirma tu direcci\xf3n de correo electr\xf3nico para ver una lista de los productos disponibles.",
    'fabric.atlassianSwitcher.goals': 'Metas',
    'fabric.atlassianSwitcher.home': 'Atlassian Home',
    'fabric.atlassianSwitcher.instantAccessStatusText': "Acceso instant\xe1neo",
    'fabric.atlassianSwitcher.jiraDescriptionText': 'Planificar y realizar un seguimiento de la entrega del proyecto',
    'fabric.atlassianSwitcher.jiraProject': 'Proyecto Jira',
    'fabric.atlassianSwitcher.join': 'Unirse',
    'fabric.atlassianSwitcher.joinStatusText': 'Unirse',
    'fabric.atlassianSwitcher.joinTeamStatusText': 'Unirse al equipo',
    'fabric.atlassianSwitcher.jpdDescriptionText': 'Priorizar y planificar nuevas ideas',
    'fabric.atlassianSwitcher.jsmDescriptionText': 'Automatiza y ofrece asistencia de TI',
    'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription': 'Gestiona proyectos para equipos empresariales.',
    'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription': 'Gestiona proyectos empresariales de forma gratuita con Jira Software.',
    'fabric.atlassianSwitcher.login': "Iniciar sesi\xf3n",
    'fabric.atlassianSwitcher.manageList': 'Administrar lista',
    'fabric.atlassianSwitcher.modalLabel': 'Intercambiador de aplicaciones de Atlassian',
    'fabric.atlassianSwitcher.more': "M\xe1s",
    'fabric.atlassianSwitcher.newLozenge': 'Novedad',
    'fabric.atlassianSwitcher.organisationsLabel': 'Organizaciones',
    'fabric.atlassianSwitcher.product.description.compass': 'Gestor de componentes',
    'fabric.atlassianSwitcher.product.description.confluence': "Colaboraci\xf3n en documentos",
    'fabric.atlassianSwitcher.product.description.jsm': "Gesti\xf3n de servicios de TI de colaboraci\xf3n",
    'fabric.atlassianSwitcher.product.description.jsw': 'Seguimiento de proyectos e incidencias',
    'fabric.atlassianSwitcher.product.description.opsgenie': "Gesti\xf3n de incidentes moderna",
    'fabric.atlassianSwitcher.requestAccessStatusText': 'Solicitar acceso',
    'fabric.atlassianSwitcher.requestSentStatusText': 'Solicitud enviada',
    'fabric.atlassianSwitcher.resizeBarLabel': '"Expandir" o "Contraer" dependiendo del estado',
    'fabric.atlassianSwitcher.resizeBarTooltipCollapsed': "Arrastra para cambiar el tama\xf1o{separator}Pulsa para ampliar",
    'fabric.atlassianSwitcher.resizeBarTooltipExpanded': "Arrastra para cambiar el tama\xf1o{separator}Pulsa para contraer",
    'fabric.atlassianSwitcher.resizeBarValueTextLabel': 'Ancho',
    'fabric.atlassianSwitcher.search': 'Buscar',
    'fabric.atlassianSwitcher.sites': '{numSites, plural, one {{productName} sitio} other {{productName} sitios}}',
    'fabric.atlassianSwitcher.skeletonLoaderAriaLabel': "El Intercambiador de aplicaciones se est\xe1 cargando",
    'fabric.atlassianSwitcher.start': 'Inicio de Atlassian',
    'fabric.atlassianSwitcher.startAriaLabel': "Inicio de Atlassian se abre en una nueva pesta\xf1a",
    'fabric.atlassianSwitcher.studio': 'Estudio',
    'fabric.atlassianSwitcher.successFlag.description': "Recibir\xe1s un correo electr\xf3nico cuando se haya aprobado",
    'fabric.atlassianSwitcher.successFlag.title': 'Solicitud de acceso enviada al administrador',
    'fabric.atlassianSwitcher.switchSitesOrAppsTooltip': 'Cambiar sitios o aplicaciones',
    'fabric.atlassianSwitcher.switchTo': 'Cambiar a',
    'fabric.atlassianSwitcher.switchToTooltip': "Cambiar a\u2026",
    'fabric.atlassianSwitcher.teams': 'Equipos',
    'fabric.atlassianSwitcher.tryLozenge': "Pru\xe9balo",
    'fabric.atlassianSwitcher.yourApps': 'Tus aplicaciones',
    'fabric.atlassianSwitcher.yourAppsTooltip': "Tus aplicaciones\u2026"
};

});


//# sourceMappingURL=@atlaskit-internal_async-atlassian-switcher-i18n-es.b47b07c2.js.map
